<template>
  <el-input ref="myInputIntNumber" class="my_input_int_number" v-model="number" @input="input_number" @change="change_number" :size="size" @keyup.enter.native="change_number" :disabled="disabled"></el-input>
</template>

<script>
export default {
  name: 'my_input_int_number',
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Infinity
    },
    size: {
      type: String,
      default: 'medium'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (val) {
      this.number = this.value,
      this.numberTemp = this.value,
      this.result = val
    },
    result (val) {
      this.$emit('input', val)
    }
  },
  data () {
    return {
      number: this.value,
      numberTemp: this.value,
      result: this.value
    }
  },
  methods: {
    input_number (number) {
      if (number === '') {
        this.numberTemp = this.min
        return
      }
      if (this.is_int(number)) {
        this.number = number
        this.numberTemp = number
        if (number > this.max) {
          this.number = this.max
          this.numberTemp = this.max
        }
      } else {
        this.number = this.numberTemp
      }
      this.result = Number(this.number)
    },
    change_number (number) {
      if (number === '' || Number(number) === 0) {
        this.number = this.min
        this.numberTemp = this.min
        this.result = this.min
      }
      this.$refs.myInputIntNumber.blur()
      this.$emit('change', this.number)
    },
    is_int (number) {
      // 0和第一位不为0的正整数
      const reg = /^(0|[1-9]\d*)$/
      return reg.test(number)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/my_input_int_number/index.vue